import { render, staticRenderFns } from "./StagingAuthorFormStepOne.vue?vue&type=template&id=2a877aa3"
import script from "./StagingAuthorFormStepOne.vue?vue&type=script&lang=ts"
export * from "./StagingAuthorFormStepOne.vue?vue&type=script&lang=ts"
import style0 from "./StagingAuthorFormStepOne.vue?vue&type=style&index=0&id=2a877aa3&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports